import React from "react";
import { Form } from "react-bootstrap";
import { useField } from "formik";
import { findIssuerName } from "utils/findIssuerName";
import { useSelector } from "react-redux";


const BCSelectAccountNumberField = (props) => {
    const {
        controlId,
        dropDownLabel,
        label,
        dataLabel,
        displayBank,
        dataValue,
        size,
        data,
        ...rest
    } = props;
    const [field, meta] = useField(props);

    const {issuers} = useSelector((state) => ({
        issuers: state.issuerReducer.persistedIssuers,
    }))

    return (
        <Form.Group controlId={controlId}>
            <Form.Label>{label}</Form.Label>
            <Form.Control
                {...rest}
                {...field}
                as="select"
                isInvalid={meta.error && meta.touched}
                isValid={!meta.error && meta.touched}
                size={size}
            >
                <option>{dropDownLabel}</option>
                {data?.map((item) => (
                    <option value={item[dataValue]} key={item[dataLabel]}>
                        {item[dataLabel]}
                        {displayBank ? ` - ${findIssuerName(issuers,item[displayBank])}` : ""}
                    </option>
                ))}
            </Form.Control>
            {meta.error && meta.touched ? (
                <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
            ) : null}
        </Form.Group>
    );
};

BCSelectAccountNumberField.defaultProps = {
    data: [],
    dropDownLabel: "",
    size: "md",
    dataLabel: "name",
    dataValue: "id",
    displayBank: ""
};

export default BCSelectAccountNumberField;
